
const ScheduleService = {
    get: (id) => {
        return fetch(`/api/schedule/${id}`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    list: (params = {}) => {
        const search = new URLSearchParams(params).toString();
        return fetch('/api/schedule' + (search ? `?${search}` : ''), {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    create: (event) => {
        return fetch('/api/schedule', {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(event)
        }).then(r => r.json());
    },
    update: (id, event) => {
        return fetch(`/api/schedule/${id}`, {
            method: 'PUT',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(event)
        }).then(r => r.json());
    },
    remove: (id) => {
        return fetch(`/api/schedule/${id}`, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json()).then(data =>data);
    },
    getCategories: () => {
        return fetch(`/api/schedule/categories`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    fetchParticipants: (id) => {
        return fetch(`/api/members/events/${id}/participants`, {
            method: 'GET',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    addParticipant: (scheduleId, participantId, participantType) => {
        return fetch(`/api/members/events/${scheduleId}/participants`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ participant_id: participantId, participant_type: participantType })
        }).then(r => r.json());
    },
    removeParticipant: (scheduleId, participantId) => {
        return fetch(`/api/members/events/${scheduleId}/participants/${participantId}`, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    addPlaylist: (scheduleId, playlistId) => {
        return fetch(`/api/schedule/${scheduleId}/playlists`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ playlist_id: playlistId })
        }).then(r => r.json());
    },
    removePlaylist: (scheduleId, playlistId) => {
        return fetch(`/api/schedule/${scheduleId}/playlists/${playlistId}`, {
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
        }).then(r => r.json());
    },
    formatEvent: (event) => {
        return {
            ...event,
            date: new Date(event.date),
            startTime: new Date(event.startTime),
            endTime: event.endTime ? new Date(event.endTime) : null
        }
    }
}

export default ScheduleService;

